import type { ComponentOptionsMixin } from 'vue';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        innerValue: any
        transformValue(value: any)
        parseValue(value: any)
    }
}

export const innerValueMixin: ComponentOptionsMixin = {

    data() {

        return {
            innerValue: this.transformValue(null)
        }
    },

    created() {

        this.innerValue = this.transformValue(this.modelValue);

        this.$watch('innerValue', val => {

            if(val !== this.modelValue){
                this.$emit('update:modelValue', this.parseValue(val));
            }
        });
    },

    methods: {

        transformValue(value: any) {

            return value;
        },

        parseValue(value: any) {

            return value;
        }
    },

    watch: {

        modelValue(val) {

            this.innerValue = this.transformValue(val);
        }
    }
}